/**
 * Hashes only the email value in SHA-256 (hex) for sending to third-party systems (e.g. Facebook Pixel).
 * Other payload fields are not hashed. Normalizes before hashing: trim + toLowerCase (Meta requirement).
 */
export function hashEmailSha256(email: string): Promise<string> {
  const normalized = String(email).trim().toLowerCase()
  const encoder = new TextEncoder()
  return crypto.subtle
    .digest('SHA-256', encoder.encode(normalized))
    .then(buffer => Array.from(new Uint8Array(buffer)))
    .then(bytes => bytes.map(b => b.toString(16).padStart(2, '0')).join(''))
}

/**
 * Hashes phone in SHA-256 (hex) for Meta Advanced Matching. Normalizes to E.164: digits only with leading +.
 */
export function hashPhoneSha256(phone: string): Promise<string> {
  const digits = String(phone).replace(/\D/g, '')
  const normalized = digits ? `+${digits}` : ''
  const encoder = new TextEncoder()
  return crypto.subtle
    .digest('SHA-256', encoder.encode(normalized))
    .then(buffer => Array.from(new Uint8Array(buffer)))
    .then(bytes => bytes.map(b => b.toString(16).padStart(2, '0')).join(''))
}
